{
	"changelog": {
		"footer_link": "Scrivici dal supporto",
		"footer_note": "Cerchi una versione più vecchia o vuoi segnalare un problema?",
		"hero": {
			"eyebrow": "Changelog",
			"subtitle": "Cosa è cambiato in SeaLedger, versione per versione. Le nuove funzioni, i miglioramenti e le correzioni più importanti.",
			"title": "Novità e aggiornamenti",
			"updated": "Ultimo aggiornamento · 30 giugno 2026"
		},
		"k": {
			"add": "Nuovo",
			"fix": "Fix",
			"imp": "Migliorato"
		},
		"tag": {
			"first_release": "Primo rilascio",
			"fix": "Correzioni",
			"major": "Versione principale",
			"new": "Funzioni"
		},
		"v1_0_0": {
			"date": "10 mar 2026",
			"item_1": "Scanner carte, collezione con progressi per set e creazione deck.",
			"item_2": "Database con oltre 3.000 carte e ricerca con filtri."
		},
		"v1_1_0": {
			"date": "3 apr 2026",
			"item_1": "Wishlist: segna le carte che cerchi e ritrovale al volo.",
			"item_2": "Impostazioni riorganizzate: Lingua, Notifiche, Aspetto e Informazioni."
		},
		"v1_2_0": {
			"date": "28 apr 2026",
			"item_1": "Pagina profilo ridisegnata come hub personale con statistiche cliccabili.",
			"item_2": "Modalità ospite: usa SeaLedger senza account, con i dati sul dispositivo.",
			"item_3": "Ricerca carte più veloce e con risultati più pertinenti."
		},
		"v1_2_1": {
			"date": "12 mag 2026",
			"item_1": "Risolto un raro blocco durante la scansione in condizioni di scarsa luce.",
			"item_2": "Le percentuali di completamento per set ora si aggiornano subito dopo l'aggiunta di una carta.",
			"item_3": "Sincronizzazione più rapida all'avvio dell'app."
		},
		"v1_3_0": {
			"date": "2 giu 2026",
			"item_1": "Deck builder con selezione del leader tramite picker (ricerca, colore, set e griglia).",
			"item_2": "Aggiunta carte al deck con filtri per tipo, colore, costo e set.",
			"item_3": "La wishlist ora distingue le carte desiderate per lingua."
		},
		"v1_4_0": {
			"date": "30 giu 2026",
			"item_1": "Gestione multilingua delle carte: traccia la stessa carta in EN, JP e FR con quantità e progressi separati.",
			"item_2": "Lente lingua nella collezione: filtra per vedere solo una lingua o tutte insieme.",
			"item_3": "Stato «in arrivo» per le edizioni non ancora uscite.",
			"item_4": "Lo scanner ora rileva automaticamente la lingua di stampa della carta."
		}
	},
	"collection_tracker": {
		"cta": {
			"title": "Traccia la tua collezione"
		},
		"f1": {
			"body": "Percentuali di completamento per ogni set, sempre aggiornate.",
			"title": "Progressi per set"
		},
		"f2": {
			"body": "Traccia la stessa carta in EN, JP e FR, ognuna con la sua quantità.",
			"title": "Inventario multilingua"
		},
		"f3": {
			"body": "Segna le carte che cerchi e tienile a portata quando sei al negozio.",
			"title": "Wishlist integrata"
		},
		"hero": {
			"eyebrow": "Collection tracker",
			"lead": "Trasforma scatole e raccoglitori in un registro digitale. SeaLedger traccia ogni carta per set e lingua, con percentuali di completamento aggiornate in tempo reale.",
			"title": "Traccia la tua collezione One Piece Card Game"
		}
	},
	"deck_builder": {
		"cta": {
			"title": "Crea il tuo primo mazzo"
		},
		"f1": {
			"body": "Parti dal leader e filtra le carte adatte alla tua strategia.",
			"title": "Costruzione dal leader"
		},
		"f2": {
			"body": "Ogni carta è segnata in base a cosa hai in collezione, in tutte le lingue.",
			"title": "Possedute vs mancanti"
		},
		"f3": {
			"body": "Oltre 3.000 carte con filtri per tipo, colore, costo e set.",
			"title": "Database completo"
		},
		"hero": {
			"eyebrow": "Deck builder",
			"lead": "Scegli un leader e componi il mazzo dall'intero database di carte. SeaLedger ti mostra cosa possiedi già e cosa ti serve per completarlo.",
			"title": "Crea mazzi One Piece dalla tua collezione"
		}
	},
	"footer": {
		"changelog": "Changelog",
		"collection_tracker": "Collection tracker",
		"contact": "Contatta il supporto",
		"copyright": "© 2026 SeaLedger. Tutti i diritti riservati.",
		"deck_builder": "Deck builder",
		"disclaimer": "SeaLedger è un'app indipendente dedicata ai collezionisti del One Piece Card Game. Non è ufficiale e non è affiliata, sponsorizzata o approvata da Bandai, Toei Animation, Eiichiro Oda o dagli altri titolari dei marchi e dei diritti del gioco. «One Piece», il One Piece Card Game e tutti i nomi, i marchi e le immagini delle carte appartengono ai rispettivi proprietari.",
		"disclaimer_label": "Avviso.",
		"faq": "FAQ",
		"features": "Funzionalità",
		"how": "Come funziona",
		"languages": "Lingue",
		"legal": "Legale",
		"made_with": "Fatto con cura per i collezionisti · IT",
		"news": "Novità",
		"privacy": "Privacy Policy",
		"product": "Prodotto",
		"scanner": "Scanner",
		"support": "Supporto",
		"tagline": "Il registro digitale della tua collezione di carte. Scansiona, cataloga, costruisci.",
		"terms": "Termini di servizio"
	},
	"landing": {
		"download": {
			"badge_apple_main": "App Store",
			"badge_apple_sub": "Scarica su",
			"badge_google_main": "Google Play",
			"badge_google_sub": "Disponibile su",
			"subtitle": "Gratis su iOS e Android. La tua collezione ti aspetta.",
			"title": "Inizia a mettere ordine oggi"
		},
		"faq": {
			"a1": "Sì. Puoi scansionare, catalogare e costruire deck gratuitamente. SeaLedger Pro aggiunge funzioni avanzate come statistiche estese e sincronizzazione prioritaria.",
			"a2": "Al momento inglese (EN), giapponese (JP) e francese (FR), ognuna tracciata in modo indipendente. La lingua dell'app, invece, puoi impostarla separatamente nelle impostazioni.",
			"a3": "Sì, puoi iniziare come ospite e i dati restano sul dispositivo. Creando un account sincronizzi la collezione su più dispositivi e non rischi di perderla.",
			"a4": "Il riconoscimento base funziona anche senza connessione. Per aggiornare il database con i nuovi set e sincronizzare i progressi serve la rete.",
			"a5": "No. SeaLedger è un progetto indipendente dedicato ai collezionisti del One Piece Card Game, non affiliato né approvato da Bandai o dagli altri titolari dei marchi. Vedi il disclaimer in fondo alla pagina.",
			"eyebrow": "FAQ",
			"q1": "SeaLedger è gratuita?",
			"q2": "Quali lingue delle carte sono supportate?",
			"q3": "Posso usarla senza creare un account?",
			"q4": "Lo scanner funziona offline?",
			"q5": "SeaLedger è un'app ufficiale?",
			"title": "Domande frequenti"
		},
		"features": {
			"collection_body": "Progressi per set, percentuali di completamento e stato di ogni carta sempre aggiornati.",
			"collection_title": "Collezione viva",
			"deck_body": "Componi i deck con leader e carte dal catalogo, con suggerimenti su cosa possiedi e cosa manca.",
			"deck_title": "Deck builder",
			"eyebrow": "Funzionalità",
			"multilang_body": "Tieni traccia della stessa carta in EN, JP e FR, ciascuna con la sua quantità e i suoi progressi.",
			"multilang_title": "Multilingua reale",
			"scanner_body": "Riconoscimento carta dalla fotocamera con rilevamento automatico di set, numero e lingua.",
			"scanner_title": "Scanner intelligente",
			"search_body": "Filtra per tipo, colore, costo e set per trovare in un attimo qualsiasi carta del database.",
			"search_title": "Ricerca avanzata",
			"subtitle": "Un'unica app per tracciare, cercare, desiderare e giocare.",
			"title": "Tutto quello che serve a un collezionista",
			"wishlist_body": "Segna le carte che cerchi, per ogni lingua, e tienile a portata di mano quando sei al negozio.",
			"wishlist_title": "Wishlist"
		},
		"hero": {
			"badge_apple_main": "App Store",
			"badge_apple_sub": "Scarica su",
			"badge_google_main": "Google Play",
			"badge_google_sub": "Disponibile su",
			"eyebrow": "Dedicata al One Piece Card Game",
			"lead": "L'app pensata per i collezionisti del One Piece Card Game: scansiona una carta con la fotocamera, tienine traccia in ogni lingua e costruisci i tuoi deck. SeaLedger trasforma scatole e raccoglitori in un registro digitale sempre con te.",
			"phone_collection": "Collezione",
			"stat_db_label": "carte nel database",
			"stat_db_value": "3.000+",
			"stat_langs": "EN · JP · FR",
			"stat_rating_label": "★ su App Store",
			"stat_rating_value": "4,8",
			"title_em": "finalmente in ordine.",
			"title_lead": "La tua collezione,"
		},
		"how_it_works": {
			"eyebrow": "Come funziona",
			"step_1_body": "Inquadra la carta: SeaLedger la riconosce, identifica set e numero e rileva automaticamente la lingua di stampa.",
			"step_1_title": "Scansiona",
			"step_2_body": "Aggiungila alla collezione con un tocco. Quantità, lingua posseduta e stato di lettura aggiornano i tuoi progressi in tempo reale.",
			"step_2_title": "Cataloga",
			"step_3_body": "Crea i tuoi deck scegliendo leader e carte dal database. SeaLedger ti dice cosa possiedi già e cosa manca all'appello.",
			"step_3_title": "Costruisci",
			"subtitle": "Niente fogli di calcolo, niente conteggi a mano. Inquadra, conferma, fatto.",
			"title": "Dalla scatola al registro in tre passi"
		},
		"languages": {
			"body": "La lingua non è un'etichetta forzata: è una lente. Filtra la collezione per vedere solo l'inglese, il giapponese o il francese — oppure tutto insieme. Ogni lingua ha la sua quantità, il suo stato e la sua percentuale.",
			"eyebrow": "La differenza SeaLedger",
			"lang_en": "Inglese",
			"lang_fr": "Francese",
			"lang_jp": "Giapponese",
			"lang_total": "Totale",
			"list_1_label": "Possesso per lingua.",
			"list_1_text": "Sai esattamente quale versione hai e quale ti manca.",
			"list_2_label": "Stato «in arrivo».",
			"list_2_text": "Le edizioni non ancora uscite hanno un loro stato dedicato.",
			"list_3_label": "Rilevamento automatico.",
			"list_3_text": "Lo scanner capisce da solo la lingua di stampa.",
			"tab_all": "Tutte",
			"tab_en": "EN",
			"tab_fr": "FR",
			"tab_jp": "JP",
			"title": "Una carta, più lingue. Ogni progresso al suo posto."
		}
	},
	"mail_link": {
		"actions": {
			"download": "Ottieni SeaLedger",
			"support": "Contatta il supporto"
		},
		"eyebrow": "Link email protetto",
		"flows": {
			"change_email_new": {
				"destination": "In SeaLedger apri Impostazioni → Account e sicurezza → Email, poi ripeti il cambio se l’app te lo chiede.",
				"subtitle": "Questo link conferma il nuovo indirizzo durante un cambio email. La conferma appartiene alla tua sessione SeaLedger autenticata.",
				"title": "Conferma la nuova email in SeaLedger"
			},
			"change_email_old": {
				"destination": "In SeaLedger apri Impostazioni → Account e sicurezza → Email, poi ripeti il cambio se l’app te lo chiede.",
				"subtitle": "Questo link conferma l’indirizzo attuale prima di un cambio email. La conferma appartiene alla tua sessione SeaLedger autenticata.",
				"title": "Conferma l’email attuale in SeaLedger"
			},
			"invite": {
				"destination": "Dopo aver installato SeaLedger, torna all’invito e aprilo di nuovo per portare il referral nell’app.",
				"subtitle": "Un collezionista ti ha invitato su SeaLedger. Apri l’invito su un dispositivo con l’app installata per continuare.",
				"title": "Il tuo invito SeaLedger è pronto"
			},
			"magic_link": {
				"destination": "SeaLedger completerà l’accesso. Se il tuo account usa l’autenticazione a due fattori, l’app ti chiederà lì il passaggio successivo.",
				"subtitle": "Questo link di accesso monouso va completato in SeaLedger, così la nuova sessione resta protetta sul tuo dispositivo.",
				"title": "Continua l’accesso in SeaLedger"
			},
			"reset_password": {
				"destination": "SeaLedger aprirà la schermata di recupero, dove puoi scegliere una nuova password e completare l’operazione in sicurezza.",
				"subtitle": "Questo link monouso autorizza il recupero della password. Completalo in SeaLedger, così la nuova sessione resta sul tuo dispositivo.",
				"title": "Reimposta la password in SeaLedger"
			},
			"verify_email": {
				"destination": "SeaLedger verificherà l’indirizzo e aprirà il tuo account oppure ti chiederà il passaggio di sicurezza successivo.",
				"subtitle": "Questo link monouso verifica il tuo indirizzo email. Completalo in SeaLedger per mantenere la verifica legata al tuo account.",
				"title": "Verifica la tua email in SeaLedger"
			}
		},
		"missing": {
			"body": "L’indirizzo non contiene la prova inviata via email. Chiedi un nuovo messaggio da SeaLedger invece di modificare questo URL.",
			"title": "Questo link è incompleto"
		},
		"ready": {
			"body": "Per proteggere il tuo account, SeaLedger completa questa azione nell’app mobile. Questa pagina non mostra né conserva la prova monouso.",
			"title": "Il link ha raggiunto SeaLedger"
		},
		"recovery": {
			"body": "Se SeaLedger dice che il link è scaduto o è già stato usato, ripeti la stessa azione nell’app. Ti invieremo una nuova email con un link nuovo.",
			"kicker": "Link scaduto o già usato?",
			"security": "Non inoltrare l’email e non incollare il link in un messaggio: chi possiede una prova ancora valida potrebbe agire sul tuo account.",
			"title": "Riparti senza restare bloccato"
		},
		"steps": {
			"install": "Installa SeaLedger se serve, poi apri l’app su questo dispositivo.",
			"reopen": "Torna all’email originale e tocca di nuovo il link. L’app installata prenderà in carico l’azione.",
			"title": "Completa in tre passaggi"
		}
	},
	"nav": {
		"download": "Scarica",
		"features": "Funzionalità",
		"how": "Come funziona",
		"language": "Lingua",
		"menu": "Menu",
		"news": "Novità",
		"support": "Supporto"
	},
	"privacy": {
		"callout": {
			"body_middle": " strutturato a scopo dimostrativo e ",
			"body_prefix": "Questo testo è un ",
			"body_suffix": ". Adattalo alle tue prassi reali di trattamento dati e fallo verificare da un professionista (es. conformità GDPR) prima della pubblicazione.",
			"no_legal_advice": "non costituisce consulenza legale",
			"placeholder_word": "placeholder",
			"title": "Modello di bozza."
		},
		"hero": {
			"eyebrow": "Legale",
			"subtitle": "Quali dati raccogliamo, perché li usiamo e quali diritti hai. La tua collezione è tua: noi la custodiamo, non la vendiamo.",
			"title": "Privacy Policy",
			"updated": "In vigore dal · 30 giugno 2026"
		},
		"p1": {
			"body_prefix": "Il titolare del trattamento dei dati è il team di SeaLedger. Per esercitare i tuoi diritti o per domande sulla privacy puoi contattarci all'indirizzo ",
			"body_suffix": ".",
			"email": "privacy@sealedger.app",
			"title": "Titolare del trattamento"
		},
		"p10": {
			"body_middle": " o dalla pagina ",
			"body_prefix": "Per qualsiasi domanda sulla privacy scrivici all'indirizzo ",
			"body_suffix": ".",
			"email": "privacy@sealedger.app",
			"support_link": "Contatta il supporto",
			"title": "Contatti"
		},
		"p2": {
			"guest_note": "Se usi SeaLedger come ospite, i dati della collezione restano sul dispositivo finché non crei un account.",
			"item_account_desc": " nome utente ed email, se crei un account.",
			"item_account_label": "Dati di account:",
			"item_collection_desc": " carte, quantità, lingue, wishlist e deck che inserisci.",
			"item_collection_label": "Dati della collezione:",
			"item_technical_desc": " tipo di dispositivo, versione dell'app e dati diagnostici aggregati.",
			"item_technical_label": "Dati tecnici:",
			"item_usage_desc": " interazioni anonime utili a migliorare il prodotto.",
			"item_usage_label": "Dati d'uso:",
			"title": "Dati che raccogliamo"
		},
		"p3": {
			"item_communications": "inviarti comunicazioni di servizio (es. avvisi importanti).",
			"item_features": "migliorare stabilità, prestazioni e nuove funzioni;",
			"item_progress": "mantenere aggiornati i progressi della tua collezione;",
			"item_sync": "fornire e sincronizzare il servizio tra i tuoi dispositivi;",
			"title": "Perché usiamo i tuoi dati"
		},
		"p4": {
			"body_prefix": "Lo scanner usa la fotocamera solo per riconoscere le carte. Le immagini inquadrate sono elaborate per identificare la carta e ",
			"body_suffix": " come archivio fotografico, salvo tua esplicita azione di salvataggio.",
			"not_stored": "non vengono conservate",
			"title": "Fotocamera e scansioni"
		},
		"p5": {
			"body": "Conserviamo i dati dell'account finché l'account è attivo. Puoi richiedere la cancellazione in qualsiasi momento; dopo la richiesta i dati associati vengono eliminati entro tempi ragionevoli, salvo obblighi di legge.",
			"title": "Conservazione dei dati"
		},
		"p6": {
			"body": "Non vendiamo i tuoi dati. Possiamo avvalerci di fornitori (es. hosting, analitiche) che trattano i dati per nostro conto e secondo nostre istruzioni. Possiamo divulgare dati se richiesto dalla legge.",
			"title": "Condivisione con terzi"
		},
		"p7": {
			"body_prefix": "In base alla normativa applicabile, hai diritto di accedere, rettificare, cancellare e portare con te i tuoi dati, oltre a opporti o limitarne il trattamento. Per esercitare questi diritti scrivici dalla pagina ",
			"body_suffix": ".",
			"support_link": "supporto",
			"title": "I tuoi diritti"
		},
		"p8": {
			"body": "SeaLedger non è destinato ai minori al di sotto dell'età minima prevista dalla legge locale. Non raccogliamo consapevolmente dati di minori senza il consenso di chi esercita la responsabilità genitoriale.",
			"title": "Minori"
		},
		"p9": {
			"body": "Possiamo aggiornare questa informativa. In caso di modifiche rilevanti te lo comunicheremo nell'app o via email, aggiornando la data «in vigore dal» in cima alla pagina.",
			"title": "Modifiche a questa policy"
		},
		"see_also": {
			"body_prefix": "Vedi anche i ",
			"body_suffix": ".",
			"terms_link": "Termini di servizio"
		},
		"toc": {
			"p1": "1. Titolare",
			"p10": "10. Contatti",
			"p2": "2. Dati raccolti",
			"p3": "3. Finalità",
			"p4": "4. Fotocamera",
			"p5": "5. Conservazione",
			"p6": "6. Condivisione",
			"p7": "7. I tuoi diritti",
			"p8": "8. Minori",
			"p9": "9. Modifiche",
			"title": "Indice"
		}
	},
	"scanner": {
		"cta": {
			"title": "Inizia a scansionare oggi"
		},
		"f1": {
			"body": "EN, JP e FR riconosciute da sole, senza etichette manuali.",
			"title": "Riconoscimento lingua automatico"
		},
		"f2": {
			"body": "Il riconoscimento di base funziona senza connessione; sincronizzi quando torni online.",
			"title": "Funziona offline"
		},
		"f3": {
			"body": "Ogni scansione aggiorna i progressi per set e le quantità possedute in tempo reale.",
			"title": "Catalogazione istantanea"
		},
		"hero": {
			"eyebrow": "Scanner delle carte",
			"lead": "Inquadra qualsiasi carta One Piece Card Game con la fotocamera. SeaLedger riconosce set, numero e lingua di stampa in automatico e la aggiunge alla collezione con un solo tocco.",
			"title": "Scansiona le tue carte One Piece in pochi secondi"
		}
	},
	"seo": {
		"changelog": {
			"description": "Scopri le novità di SeaLedger: le ultime funzioni, i miglioramenti e le correzioni dell'app per collezioni One Piece Card Game.",
			"title": "Changelog — Aggiornamenti SeaLedger"
		},
		"collection_tracker": {
			"description": "Traccia la tua collezione One Piece Card Game per set e per lingua. Vedi le percentuali di completamento per EN, JP e FR a colpo d'occhio. Gratis su iOS e Android.",
			"title": "Tracker per collezioni One Piece Card Game — SeaLedger"
		},
		"deck_builder": {
			"description": "Crea mazzi One Piece Card Game con leader e carte da un database di oltre 3.000 carte. Scopri cosa possiedi e cosa ti manca. Gratis su iOS e Android.",
			"title": "Deck builder per One Piece Card Game — SeaLedger"
		},
		"home": {
			"description": "Scansiona, cataloga e traccia la tua collezione One Piece Card Game in ogni lingua. Crea mazzi, gestisci la wishlist e segui i progressi per set. Gratis su iOS e Android.",
			"title": "SeaLedger — Scanner e tracker per collezioni One Piece Card Game"
		},
		"privacy": {
			"description": "Come SeaLedger tratta e protegge i tuoi dati. La tua collezione è tua: la teniamo al sicuro e non la vendiamo.",
			"title": "Informativa sulla privacy — SeaLedger"
		},
		"scanner": {
			"description": "Scansiona le carte One Piece Card Game con la fotocamera. SeaLedger riconosce set, numero e lingua in automatico, anche offline. Gratis su iOS e Android.",
			"title": "App scanner per One Piece Card Game — SeaLedger"
		},
		"support": {
			"description": "Ricevi assistenza su SeaLedger: scanner delle carte, sincronizzazione, account e SeaLedger Pro. Trova risposte alle domande frequenti e contattaci.",
			"title": "Supporto — SeaLedger"
		},
		"terms": {
			"description": "Leggi i Termini di servizio di SeaLedger, l'app per collezioni One Piece Card Game.",
			"title": "Termini di servizio — SeaLedger"
		}
	},
	"support": {
		"contacts": {
			"email_label": "Email",
			"email_value": "supporto@sealedger.app",
			"heading": "Contatti diretti",
			"hours_label": "Orari",
			"hours_value": "Lun–Ven · 9:00–18:00 (CET)",
			"response_label": "Tempo di risposta",
			"response_value": "In media entro 1 giorno lavorativo"
		},
		"faq": {
			"eyebrow": "FAQ",
			"heading": "Forse trovi subito la risposta",
			"q1": {
				"answer": "Assicurati di avere buona luce e che la carta sia ben inquadrata. Se persiste, aggiungila manualmente dalla ricerca e segnalacela: aggiorniamo spesso il database.",
				"question": "Lo scanner non riconosce una carta, cosa faccio?"
			},
			"q2": {
				"answer": "Se usavi la modalità ospite i dati erano solo sul vecchio dispositivo. Con un account la collezione si sincronizza: accedi con le stesse credenziali per ritrovarla.",
				"question": "Ho perso la collezione dopo aver cambiato telefono."
			},
			"q3": {
				"answer": "Rinnovo e disdetta si gestiscono dalle impostazioni del tuo App Store o Google Play, dalla sezione abbonamenti del tuo account dello store.",
				"question": "Come gestisco l'abbonamento SeaLedger Pro?"
			},
			"q4": {
				"answer": "Scrivici dal form scegliendo «Segnalazione carta mancante / errata» e indica set, numero e lingua: correggiamo nel più breve tempo possibile.",
				"question": "Una carta del database è errata o manca."
			},
			"q5": {
				"answer_email": "privacy@sealedger.app",
				"answer_part1": "Puoi richiederlo dal form o scrivendo a",
				"answer_part2": ". Maggiori dettagli nella",
				"answer_policy_link": "Privacy Policy",
				"question": "Voglio cancellare il mio account e i miei dati."
			}
		},
		"form": {
			"card_heading": "Invia una richiesta",
			"card_sub": "Più dettagli ci dai, prima riusciamo ad aiutarti.",
			"categories": {
				"account": "Account e accesso",
				"card_report": "Segnalazione carta mancante / errata",
				"collection": "Collezione o sincronizzazione",
				"other": "Altro",
				"scanner": "Problema con lo scanner",
				"subscription": "Abbonamento SeaLedger Pro"
			},
			"errors": {
				"email_invalid": "Inserisci un indirizzo email valido",
				"message_required": "Il messaggio è obbligatorio",
				"name_required": "Il nome è obbligatorio",
				"subject_required": "L'oggetto è obbligatorio"
			},
			"fields": {
				"category_label": "Categoria",
				"email_label": "Email",
				"email_placeholder": "tu@esempio.com",
				"message_label": "Messaggio",
				"message_placeholder": "Descrivi cosa succede, su quale dispositivo e in quale schermata…",
				"name_label": "Nome",
				"name_placeholder": "Il tuo nome",
				"subject_label": "Oggetto",
				"subject_placeholder": "Riassumi in una riga"
			},
			"note_device": "Indica modello del dispositivo e versione dell'app (Impostazioni → Informazioni) per un aiuto più rapido.",
			"privacy_link_text": "Privacy Policy",
			"privacy_note_prefix": "Inviando accetti la nostra",
			"submit": "Invia richiesta"
		},
		"hero": {
			"description": "Scrivici dal form qui sotto, dai un'occhiata alle domande frequenti o usa i recapiti diretti. Rispondiamo a tutti.",
			"eyebrow": "Supporto",
			"title": "Come possiamo aiutarti?"
		},
		"status": {
			"degraded": "Servizio non disponibile",
			"degraded_description": "Il backend non risponde correttamente alla richiesta di health check.",
			"description": "Scanner, sincronizzazione e database funzionano regolarmente.",
			"heading": "Stato del servizio",
			"ok": "Tutti i sistemi operativi"
		},
		"toast": {
			"message": "Richiesta inviata — ti risponderemo via email."
		}
	},
	"terms": {
		"callout": {
			"label": "Modello di bozza.",
			"mid_emphasis": " strutturato a scopo dimostrativo e ",
			"no_legal": "non costituisce consulenza legale",
			"placeholder_word": "placeholder",
			"post_emphasis": ". Prima della pubblicazione fallo rivedere e adattare da un professionista legale in base alla tua giurisdizione.",
			"pre_placeholder": " Questo testo è un "
		},
		"footer_note": {
			"post": ".",
			"pre": "Vedi anche la ",
			"privacy_link": "Privacy Policy"
		},
		"hero": {
			"effective": "In vigore dal · 7 agosto 2026",
			"eyebrow": "Legale",
			"subtitle": "Le regole d'uso di SeaLedger. Usando l'app accetti i termini descritti in questa pagina.",
			"title": "Termini di servizio"
		},
		"s1": {
			"body": "Scaricando, installando o utilizzando SeaLedger («l'app», «il servizio») accetti integralmente i presenti Termini di servizio. Se non li accetti, ti chiediamo di non utilizzare l'app.",
			"title": "Accettazione dei termini"
		},
		"s10": {
			"body": "Nei limiti consentiti dalla legge, SeaLedger non è responsabile per danni indiretti, incidentali o consequenziali derivanti dall'uso o dall'impossibilità di usare il servizio, inclusa l'eventuale perdita di dati.",
			"title": "Limitazione di responsabilità"
		},
		"s11": {
			"body": "Possiamo aggiornare questi termini. In caso di modifiche sostanziali te ne daremo avviso nell'app o via email. L'uso continuato dopo l'aggiornamento costituisce accettazione dei nuovi termini.",
			"title": "Modifiche ai termini"
		},
		"s12": {
			"body_mid": " o all'indirizzo ",
			"body_post": ".",
			"body_pre": "I presenti termini sono regolati dalla legge applicabile da indicare in base alla tua sede. Per qualsiasi domanda scrivici dalla pagina ",
			"support_link": "Contatta il supporto",
			"title": "Legge applicabile e contatti"
		},
		"s2": {
			"body": "SeaLedger è un'applicazione che consente ai collezionisti di catalogare le carte del One Piece Card Game, tracciarne il possesso in diverse lingue, gestire una wishlist e costruire deck. Il servizio è fornito «così com'è» e può evolvere nel tempo.",
			"title": "Descrizione del servizio"
		},
		"s3": {
			"body": "Puoi usare SeaLedger come ospite oppure creare un account per sincronizzare i dati. Sei responsabile della riservatezza delle tue credenziali e di ogni attività svolta tramite il tuo account.",
			"item1": "Devi fornire informazioni accurate in fase di registrazione.",
			"item2": "Devi avere l'età minima prevista dalla legge della tua giurisdizione.",
			"item3": "Devi avvisarci tempestivamente in caso di uso non autorizzato del tuo account.",
			"title": "Account utente"
		},
		"s4": {
			"body": "Ti impegni a utilizzare SeaLedger nel rispetto della legge e a non:",
			"item1": "tentare di accedere senza autorizzazione ai sistemi o ai dati di altri utenti;",
			"item2": "interferire con il funzionamento del servizio o aggirarne le misure di sicurezza;",
			"item3": "utilizzare l'app per scopi illeciti, fraudolenti o lesivi di diritti altrui.",
			"title": "Uso consentito"
		},
		"s5": {
			"body": "I dati che inserisci (collezione, deck, note) restano tuoi. Concedendoci una licenza limitata, ci autorizzi a elaborarli al solo fine di fornirti il servizio, ad esempio per la sincronizzazione tra dispositivi.",
			"title": "Contenuti dell'utente"
		},
		"s6": {
			"body": "SeaLedger è un progetto indipendente. Non è affiliato, sponsorizzato né approvato dai titolari dei marchi e dei diritti sulle carte. Nomi, immagini e marchi delle carte appartengono ai rispettivi proprietari e sono utilizzati a soli fini identificativi e di catalogazione.",
			"title": "Marchi e diritti di terzi"
		},
		"s7": {
			"body": "Alcune funzioni avanzate possono richiedere SeaLedger Pro, un abbonamento a pagamento gestito tramite App Store o Google Play. Rinnovi, prezzi e cancellazioni sono soggetti anche alle condizioni del rispettivo store.",
			"title": "Abbonamenti e acquisti"
		},
		"s8": {
			"body": "Il servizio è fornito «così com'è» e «come disponibile». Pur impegnandoci per l'accuratezza del database, non garantiamo che sia privo di errori, completo o sempre disponibile.",
			"title": "Esclusione di garanzie"
		},
		"s9": {
			"body": "SeaLedger mostra dati di mercato e valori stimati per aiutarti a organizzare la collezione. Queste informazioni hanno natura indicativa.",
			"item1": "I dati provengono da fonti terze e possono essere ritardati, incompleti, inesatti o temporaneamente indisponibili.",
			"item2": "Le carte di valore molto basso sono supportate, ma possono essere aggiornate meno frequentemente; arrotondamenti e piccole oscillazioni possono incidere in modo rilevante sul dato mostrato.",
			"item3": "Il valore stimato di una carta o della collezione dipende dai prezzi disponibili, dalla fonte, dalla condizione, dalla valuta e dall'ultimo aggiornamento; le carte senza prezzo possono non contribuire al totale.",
			"item4": "Nessun prezzo o valore stimato costituisce una garanzia di vendita o acquisto, una perizia professionale, una consulenza finanziaria, un'offerta o un impegno di SeaLedger o delle fonti terze.",
			"title": "Prezzi di mercato e valori stimati"
		},
		"toc": {
			"heading": "Indice",
			"s1": "1. Accettazione",
			"s10": "10. Responsabilità",
			"s11": "11. Modifiche",
			"s12": "12. Legge e contatti",
			"s2": "2. Il servizio",
			"s3": "3. Account",
			"s4": "4. Uso consentito",
			"s5": "5. Contenuti",
			"s6": "6. Marchi di terzi",
			"s7": "7. Abbonamenti",
			"s8": "8. Garanzie",
			"s9": "9. Prezzi e valori stimati"
		}
	}
}
